import { DirectSalesCodeNameModel, DirectSalesLineObjective } from 'components/common/types/DirectSalesCampaign.types';
import { FormatCategory, LocationCategory } from 'store/userOptions/reducer.types';
import { ObjectiveMapEntry } from './Objectives.types';

export type GroupSelectionCodesReturn = Record<
  keyof typeof FormatCategory | keyof typeof LocationCategory | string,
  { included: Set<string>; excluded: Set<string> }
>;

export const groupSelectionCodes =
  (categories: Record<string, keyof typeof FormatCategory | keyof typeof LocationCategory | string>) =>
  (values: DirectSalesCodeNameModel[]): GroupSelectionCodesReturn => {
    return values.reduce((acc: GroupSelectionCodesReturn, curr: DirectSalesCodeNameModel) => {
      if (!curr?.category) return acc;

      const category = categories[curr.category] || curr.category;

      if (!acc[category]) acc[category] = { included: new Set(), excluded: new Set() };

      if (curr.include) acc[category].included.add(curr.code);
      else acc[category].excluded.add(curr.code);
      return acc;
    }, {});
  };

export const groupFormatSelectionCodes = (values: DirectSalesCodeNameModel[]): GroupSelectionCodesReturn => {
  return groupSelectionCodes(FormatCategory)(values);
};

export const groupLocationSelectionCodes = (values: DirectSalesCodeNameModel[]): GroupSelectionCodesReturn => {
  return groupSelectionCodes(LocationCategory)(values);
};

export const groupTagSelectionCodes = (values: DirectSalesCodeNameModel[]): GroupSelectionCodesReturn => {
  return groupSelectionCodes({})(values);
};

export const createObjectivesMap = (objectives: DirectSalesLineObjective[]): Map<number, ObjectiveMapEntry> => {
  return new Map<number, ObjectiveMapEntry>(
    objectives.map((objective, index) => [objective.objectiveGroupId, { objective, index }]),
  );
};

export const objectiveExists = (objectivesMap: Map<number, ObjectiveMapEntry>, objectiveGroupId: number): boolean => {
  return objectivesMap.has(objectiveGroupId);
};

export const isIncludedEmpty = (data: GroupSelectionCodesReturn): boolean => {
  return Object.values(data).every((category) => category.included.size === 0);
};

export const isExcludedEmpty = (data: GroupSelectionCodesReturn): boolean => {
  return Object.values(data).every((category) => category.excluded.size === 0);
};
